export const ENVIRONMENTS = {
  PRODUCTION: 'production',
  PRE_PRODUCTION: 'pre-production',
  DEVELOPMENT: 'development',
  TEST: 'test',
} as const;

// Security
export const WEBHOOKS_UUID_NAMESPACE = 'b8edf0f7-f5c3-4ba1-a179-0b33660a41d8';
